"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CraAttributes = exports.CraAttributeType = exports.CraAttributeName = void 0;
const attribute_options_1 = require("./attribute-options");
var CraAttributeName;
(function (CraAttributeName) {
    CraAttributeName["FacilityType"] = "facilityType";
    CraAttributeName["FacilityAccess"] = "facilityAccess";
    CraAttributeName["LooseOrSlipperySurface"] = "looseOrSlipperySurface";
    CraAttributeName["TramOrTrainRails"] = "tramOrTrainRails";
    CraAttributeName["MajorSurfaceDeformationOrDrainOpening"] = "majorSurfaceDeformationOrDrainOpening";
    CraAttributeName["FixedObstacleOnFacility"] = "fixedObstacleOnFacility";
    CraAttributeName["NonFixedObstacleOnFacility"] = "nonFixedObstacleOnFacility";
    CraAttributeName["LineOfSight"] = "lineOfSight";
    CraAttributeName["Delineation"] = "delineation";
    CraAttributeName["LightSegregation"] = "lightSegregation";
    CraAttributeName["FacilityWidthPerDirection"] = "facilityWidthPerDirection";
    CraAttributeName["FlowDirection"] = "flowDirection";
    CraAttributeName["WidthRestriction"] = "widthRestriction";
    CraAttributeName["Grade"] = "grade";
    CraAttributeName["Curvature"] = "curvature";
    CraAttributeName["StreetLighting"] = "streetLighting";
    CraAttributeName["PedestrianCrossing"] = "pedestrianCrossing";
    CraAttributeName["IntersectionBicycleFacility"] = "intersectionBicycleFacility";
    CraAttributeName["IntersectionApproach"] = "intersectionApproach";
    CraAttributeName["IntersectionOrRoadCrossing"] = "intersectionOrRoadCrossing";
    CraAttributeName["CrossingFacility"] = "crossingFacility";
    CraAttributeName["NumberOfLanesAdjacentRoad"] = "numberOfLanesAdjacentRoad";
    CraAttributeName["NumberOfLanesIntersectingRoad"] = "numberOfLanesIntersectingRoad";
    CraAttributeName["PropertyAccess"] = "propertyAccess";
    CraAttributeName["PeakPedestrianFlowAlongOrAcrossFacility"] = "peakPedestrianFlowAlongOrAcrossFacility";
    CraAttributeName["PeakBicycleAndLVTrafficFlow"] = "peakBicycleAndLVTrafficFlow";
    CraAttributeName["ObservedProportionOfCargoBikesAndMopeds"] = "observedProportionOfCargoBikesAndMopeds";
    CraAttributeName["BicycleAndLVSpeedAverage"] = "bicycleAndLVSpeedAverage";
    CraAttributeName["BicycleAndLVSpeedDifferential"] = "bicycleAndLVSpeedDifferential";
    CraAttributeName["RoadOperatingSpeed"] = "roadOperatingSpeed";
    CraAttributeName["RoadAADT"] = "roadAADT";
    CraAttributeName["HeavyVehicleFlow"] = "heavyVehicleFlow";
    CraAttributeName["RoadSpeedLimit"] = "roadSpeedLimit";
    CraAttributeName["AdjacentFeatures0to1mRoadLane"] = "adjacentFeatures0to1m.roadLane";
    CraAttributeName["AdjacentFeatures0to1mVehicleParking"] = "adjacentFeatures0to1m.vehicleParking";
    CraAttributeName["AdjacentFeatures0to1mSevereHazard"] = "adjacentFeatures0to1m.severeHazard";
    CraAttributeName["AdjacentFeatures0to1mObjectOrLevelChange"] = "adjacentFeatures0to1m.objectOrLevelChange";
    CraAttributeName["AdjacentFeatures0to1mSidewalk"] = "adjacentFeatures0to1m.sidewalk";
    CraAttributeName["AdjacentFeatures1to3mRoadLane"] = "adjacentFeatures1to3m.roadLane";
    CraAttributeName["AdjacentFeatures1to3mVehicleParking"] = "adjacentFeatures1to3m.vehicleParking";
    CraAttributeName["AdjacentFeatures1to3mSevereHazard"] = "adjacentFeatures1to3m.severeHazard";
    CraAttributeName["AdjacentFeatures1to3mObjectOrLevelChange"] = "adjacentFeatures1to3m.objectOrLevelChange";
    CraAttributeName["AdjacentFeatures1to3mSidewalk"] = "adjacentFeatures1to3m.sidewalk";
    CraAttributeName["AreaType"] = "areaType";
    CraAttributeName["Comment"] = "comment";
})(CraAttributeName || (exports.CraAttributeName = CraAttributeName = {}));
var CraAttributeType;
(function (CraAttributeType) {
    CraAttributeType[CraAttributeType["Select"] = 0] = "Select";
    CraAttributeType[CraAttributeType["Number"] = 1] = "Number";
    CraAttributeType[CraAttributeType["TextArea"] = 2] = "TextArea";
})(CraAttributeType || (exports.CraAttributeType = CraAttributeType = {}));
const createCraAttributeSelectImage = (name, optionValues) => ({
    type: CraAttributeType.Select,
    useImageSelection: true,
    name,
    options: optionValues.map((value) => createOption(value)),
});
const createOption = (value) => ({
    value,
});
const createCraAttributeNumber = (name, min, max) => ({
    type: CraAttributeType.Number,
    name,
    min,
    max,
});
const createCraAttributeTextArea = (name) => ({
    type: CraAttributeType.TextArea,
    name,
});
var CraAttributes;
(function (CraAttributes) {
    CraAttributes.facilityType = createCraAttributeSelectImage(CraAttributeName.FacilityType, Object.values(attribute_options_1.FacilityType));
    CraAttributes.facilityAccess = createCraAttributeSelectImage(CraAttributeName.FacilityAccess, Object.values(attribute_options_1.AdequateType));
    CraAttributes.looseOrSlipperySurface = createCraAttributeSelectImage(CraAttributeName.LooseOrSlipperySurface, Object.values(attribute_options_1.PresenceType));
    CraAttributes.tramOrTrainRails = createCraAttributeSelectImage(CraAttributeName.TramOrTrainRails, Object.values(attribute_options_1.PresenceType));
    CraAttributes.majorSurfaceDeformationOrDrainOpening = createCraAttributeSelectImage(CraAttributeName.MajorSurfaceDeformationOrDrainOpening, Object.values(attribute_options_1.PresenceType));
    CraAttributes.fixedObstacleOnFacility = createCraAttributeSelectImage(CraAttributeName.FixedObstacleOnFacility, Object.values(attribute_options_1.PresenceType));
    CraAttributes.nonFixedObstacleOnFacility = createCraAttributeSelectImage(CraAttributeName.NonFixedObstacleOnFacility, Object.values(attribute_options_1.PresenceType));
    CraAttributes.lineOfSight = createCraAttributeSelectImage(CraAttributeName.LineOfSight, Object.values(attribute_options_1.AdequateType));
    CraAttributes.delineation = createCraAttributeSelectImage(CraAttributeName.Delineation, Object.values(attribute_options_1.PresenceType));
    CraAttributes.lightSegregation = createCraAttributeSelectImage(CraAttributeName.LightSegregation, Object.values(attribute_options_1.PresenceType));
    CraAttributes.facilityWidthPerDirection = createCraAttributeSelectImage(CraAttributeName.FacilityWidthPerDirection, Object.values(attribute_options_1.FacilityWidth));
    CraAttributes.flowDirection = createCraAttributeSelectImage(CraAttributeName.FlowDirection, Object.values(attribute_options_1.FlowDirectionType));
    CraAttributes.widthRestriction = createCraAttributeSelectImage(CraAttributeName.WidthRestriction, Object.values(attribute_options_1.PresenceType));
    CraAttributes.adjacentFeatures0to1mRoadLane = createCraAttributeSelectImage(CraAttributeName.AdjacentFeatures0to1mRoadLane, Object.values(attribute_options_1.PresenceType));
    CraAttributes.adjacentFeatures0to1mVehicleParking = createCraAttributeSelectImage(CraAttributeName.AdjacentFeatures0to1mVehicleParking, Object.values(attribute_options_1.PresenceType));
    CraAttributes.adjacentFeatures0to1mSevereHazard = createCraAttributeSelectImage(CraAttributeName.AdjacentFeatures0to1mSevereHazard, Object.values(attribute_options_1.PresenceType));
    CraAttributes.adjacentFeatures0to1mObjectOrLevelChange = createCraAttributeSelectImage(CraAttributeName.AdjacentFeatures0to1mObjectOrLevelChange, Object.values(attribute_options_1.PresenceType));
    CraAttributes.adjacentFeatures0to1mSidewalk = createCraAttributeSelectImage(CraAttributeName.AdjacentFeatures0to1mSidewalk, Object.values(attribute_options_1.PresenceType));
    CraAttributes.adjacentFeatures1to3mRoadLane = createCraAttributeSelectImage(CraAttributeName.AdjacentFeatures1to3mRoadLane, Object.values(attribute_options_1.PresenceType));
    CraAttributes.adjacentFeatures1to3mVehicleParking = createCraAttributeSelectImage(CraAttributeName.AdjacentFeatures1to3mVehicleParking, Object.values(attribute_options_1.PresenceType));
    CraAttributes.adjacentFeatures1to3mSevereHazard = createCraAttributeSelectImage(CraAttributeName.AdjacentFeatures1to3mSevereHazard, Object.values(attribute_options_1.PresenceType));
    CraAttributes.adjacentFeatures1to3mObjectOrLevelChange = createCraAttributeSelectImage(CraAttributeName.AdjacentFeatures1to3mObjectOrLevelChange, Object.values(attribute_options_1.PresenceType));
    CraAttributes.adjacentFeatures1to3mSidewalk = createCraAttributeSelectImage(CraAttributeName.AdjacentFeatures1to3mSidewalk, Object.values(attribute_options_1.PresenceType));
    CraAttributes.grade = createCraAttributeSelectImage(CraAttributeName.Grade, Object.values(attribute_options_1.GradeType));
    CraAttributes.curvature = createCraAttributeSelectImage(CraAttributeName.Curvature, Object.values(attribute_options_1.CurvatureType));
    CraAttributes.streetLighting = createCraAttributeSelectImage(CraAttributeName.StreetLighting, Object.values(attribute_options_1.PresenceType));
    CraAttributes.pedestrianCrossing = createCraAttributeSelectImage(CraAttributeName.PedestrianCrossing, Object.values(attribute_options_1.PresenceType));
    CraAttributes.intersectionBicycleFacility = createCraAttributeSelectImage(CraAttributeName.IntersectionBicycleFacility, Object.values(attribute_options_1.PresenceType));
    CraAttributes.intersectionApproach = createCraAttributeSelectImage(CraAttributeName.IntersectionApproach, Object.values(attribute_options_1.IntersectionApproachType));
    CraAttributes.intersectionOrRoadCrossing = createCraAttributeSelectImage(CraAttributeName.IntersectionOrRoadCrossing, Object.values(attribute_options_1.PresenceType));
    CraAttributes.crossingFacility = createCraAttributeSelectImage(CraAttributeName.CrossingFacility, Object.values(attribute_options_1.PresenceType));
    CraAttributes.numberOfLanesAdjacentRoad = createCraAttributeSelectImage(CraAttributeName.NumberOfLanesAdjacentRoad, Object.values(attribute_options_1.NumberOfLanesType));
    CraAttributes.numberOfLanesIntersectingRoad = createCraAttributeSelectImage(CraAttributeName.NumberOfLanesIntersectingRoad, Object.values(attribute_options_1.NumberOfLanesType));
    CraAttributes.propertyAccess = createCraAttributeSelectImage(CraAttributeName.PropertyAccess, Object.values(attribute_options_1.PresenceType));
    CraAttributes.peakPedestrianFlowAlongOrAcrossFacility = createCraAttributeSelectImage(CraAttributeName.PeakPedestrianFlowAlongOrAcrossFacility, Object.values(attribute_options_1.PedestrianFlowType));
    CraAttributes.peakBicycleAndLVTrafficFlow = createCraAttributeSelectImage(CraAttributeName.PeakBicycleAndLVTrafficFlow, Object.values(attribute_options_1.BicycleAndLVFlowType));
    CraAttributes.observedProportionOfCargoBikesAndMopeds = createCraAttributeSelectImage(CraAttributeName.ObservedProportionOfCargoBikesAndMopeds, Object.values(attribute_options_1.ProportionOfCargoBikesAndMopedsType));
    CraAttributes.bicycleAndLVSpeedAverage = createCraAttributeSelectImage(CraAttributeName.BicycleAndLVSpeedAverage, Object.values(attribute_options_1.SpeedAverageType));
    CraAttributes.bicycleAndLVSpeedDifferential = createCraAttributeSelectImage(CraAttributeName.BicycleAndLVSpeedDifferential, Object.values(attribute_options_1.SpeedDifferentialType));
    CraAttributes.roadAADT = createCraAttributeNumber(CraAttributeName.RoadAADT, 0, 40000);
    CraAttributes.heavyVehicleFlow = createCraAttributeSelectImage(CraAttributeName.HeavyVehicleFlow, Object.values(attribute_options_1.HeavyVehicleFlowType));
    CraAttributes.roadSpeedLimit = createCraAttributeNumber(CraAttributeName.RoadSpeedLimit);
    CraAttributes.roadOperatingSpeed = createCraAttributeNumber(CraAttributeName.RoadOperatingSpeed, 0, 150);
    CraAttributes.areaType = createCraAttributeSelectImage(CraAttributeName.AreaType, Object.values(attribute_options_1.AreaType));
    CraAttributes.comment = createCraAttributeTextArea(CraAttributeName.Comment);
    CraAttributes.byGroup = {
        facilityFeatures: [
            CraAttributes.facilityType,
            CraAttributes.facilityAccess,
            CraAttributes.looseOrSlipperySurface,
            CraAttributes.tramOrTrainRails,
            CraAttributes.majorSurfaceDeformationOrDrainOpening,
            CraAttributes.fixedObstacleOnFacility,
            CraAttributes.nonFixedObstacleOnFacility,
            CraAttributes.lineOfSight,
            CraAttributes.delineation,
            CraAttributes.lightSegregation,
            CraAttributes.facilityWidthPerDirection,
            CraAttributes.flowDirection,
            CraAttributes.widthRestriction,
        ],
        facilityContext: [
            CraAttributes.adjacentFeatures0to1mRoadLane,
            CraAttributes.adjacentFeatures0to1mVehicleParking,
            CraAttributes.adjacentFeatures0to1mSevereHazard,
            CraAttributes.adjacentFeatures0to1mObjectOrLevelChange,
            CraAttributes.adjacentFeatures0to1mSidewalk,
            CraAttributes.adjacentFeatures1to3mRoadLane,
            CraAttributes.adjacentFeatures1to3mVehicleParking,
            CraAttributes.adjacentFeatures1to3mSevereHazard,
            CraAttributes.adjacentFeatures1to3mObjectOrLevelChange,
            CraAttributes.adjacentFeatures1to3mSidewalk,
            CraAttributes.grade,
            CraAttributes.curvature,
            CraAttributes.streetLighting,
        ],
        intersectionFlows: [
            CraAttributes.pedestrianCrossing,
            CraAttributes.intersectionBicycleFacility,
            CraAttributes.intersectionApproach,
            CraAttributes.intersectionOrRoadCrossing,
            CraAttributes.crossingFacility,
            CraAttributes.numberOfLanesAdjacentRoad,
            CraAttributes.numberOfLanesIntersectingRoad,
            CraAttributes.propertyAccess,
        ],
        speedVolume: [
            CraAttributes.peakPedestrianFlowAlongOrAcrossFacility,
            CraAttributes.peakBicycleAndLVTrafficFlow,
            CraAttributes.observedProportionOfCargoBikesAndMopeds,
            CraAttributes.bicycleAndLVSpeedAverage,
            CraAttributes.bicycleAndLVSpeedDifferential,
            CraAttributes.roadAADT,
            CraAttributes.heavyVehicleFlow,
            CraAttributes.roadSpeedLimit,
            CraAttributes.roadOperatingSpeed,
        ],
        optionalAttributes: [CraAttributes.areaType, CraAttributes.comment],
    };
    CraAttributes.all = Object.values(CraAttributes.byGroup).flatMap((list) => list);
    const allByName = new Map(CraAttributes.all.map((attr) => [attr.name, attr]));
    CraAttributes.getByName = (name) => allByName.get(name);
})(CraAttributes || (exports.CraAttributes = CraAttributes = {}));
